import type { AxiosRequestConfig } from 'axios';
import http from '@/utils/http';

import type { IGameDetailBasicInfoParams } from './types';

/**
 * 小游戏基础信息接口（支持 game_id / wechat_app_id / douyin_app_id）
 */
export const fetchMiniGameDetailBasicInfo = (
  payload: IGameDetailBasicInfoParams,
  config?: Pick<AxiosRequestConfig, 'cancelToken'>,
): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/game/minigame/basic',
    method: 'post',
    data: payload,
    ...config,
    rawData: true,
  }) as Promise<any>;
};

/**
 * 小游戏趋势指标接口（趋势图与表格共用）
 */
export const fetchMiniGameDetailMetrics = (
  payload: Record<string, any>,
  config?: Pick<AxiosRequestConfig, 'cancelToken'>,
): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/game/genre_profile/metrics',
    method: 'post',
    data: payload,
    ...config,
    rawData: true,
  }) as Promise<any>;
};
